import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../components/page.tsx';
import { ComingSoon } from '../../components/ui.tsx';
import { useCurrentProperty } from '../landlord/PropertyLayout.tsx';
import { useTenant } from '../tenant/TenantShell.tsx';
import { MessagesView } from './Messages.tsx';

/** Vuokranantajan kaikki viestit sivupalkista. */
export function LandlordMessagesPage() {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('nav.messages')} />
      <MessagesView as="owner" basePath="/vuokranantaja/viestit" showProperty />
    </>
  );
}

/** Asunnon Viestit-välilehti: samat ketjut yhteen asuntoon rajattuna. */
export function LandlordMessagesTab() {
  const p = useCurrentProperty();
  return (
    <MessagesView
      as="owner"
      propertyId={p.id}
      basePath={`/vuokranantaja/asunnot/${p.id}/viestit`}
    />
  );
}

/** Vuokralaisen viestit valitun vuokra-asunnon vuokrasuhteessa. */
export function TenantMessagesPage() {
  const { t } = useTranslation();
  const { current, isLoading } = useTenant();
  if (isLoading) return null;
  return (
    <>
      <PageHeader title={t('nav.messages')} />
      {current ? (
        <MessagesView
          as="party"
          propertyId={current.id}
          basePath="/vuokralainen/viestit"
          canCreate={current.settings.tenantMessages}
        />
      ) : (
        <ComingSoon text={t('tenant.noProperty')} />
      )}
    </>
  );
}
